import React from 'react';

import styled from 'styled-components';

import aampeTheme from '../../constants/aampeTheme';
import ICONS from '../../constants/icons';

import { createShouldForwardProp } from 'helpers/shouldForwardProp';

interface DrawerNavigationProps {
    onPrevious: () => void;
    onNext: () => void;
    hasPrevious: boolean;
    hasNext: boolean;
    showLabels?: boolean;
}

const DrawerNavigation: React.FC<DrawerNavigationProps> = ({
    onPrevious,
    onNext,
    hasPrevious,
    hasNext,
    showLabels = false,
}) => {
    if (!hasPrevious && !hasNext) return null;

    return (
        <Container>
            <NavButton
                onClick={onPrevious}
                showLabels={showLabels}
                disabled={!hasPrevious}
            >
                <ICONS.leftChevron size={16} />
                {showLabels && <span>Previous</span>}
            </NavButton>
            <NavButton
                onClick={onNext}
                showLabels={showLabels}
                disabled={!hasNext}
            >
                {showLabels && <span>Next</span>}
                <ICONS.rightChevron size={16} />
            </NavButton>
        </Container>
    );
};

export default DrawerNavigation;

const Container = styled.div({
    display: 'flex',
    alignItems: 'center',
    gap: aampeTheme.spacing4(3),
});

const shouldForwardNavProps = createShouldForwardProp(['showLabels']);

const NavButton = styled.button.withConfig({
    shouldForwardProp: shouldForwardNavProps,
})<{ showLabels: boolean }>(({ showLabels }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: aampeTheme.spacing4(2),
    padding: showLabels ? aampeTheme.spacing4(2, 3) : aampeTheme.spacing4(2),
    backgroundColor: aampeTheme.colors.backgroundWG02,
    border: `1px solid ${aampeTheme.colors.bordersWG01}`,
    borderRadius: aampeTheme.borderRadius.default,
    cursor: 'pointer',
    fontSize: aampeTheme.size.font.textSmall,
    color: aampeTheme.colors.textAccessibleWG01,
    fontWeight: aampeTheme.weights.heavy,
    transition: 'background-color 0.2s ease',
    '&:hover': {
        backgroundColor: aampeTheme.colors.gray50,
    },
    '&:disabled': {
        opacity: 0.5,
        backgroundColor: aampeTheme.colors.backgroundWG02,
        color: aampeTheme.colors.textAccessibleWG01,
        '&:hover': {
            backgroundColor: aampeTheme.colors.backgroundWG02, // Prevent hover effect when disabled
        },
    },
}));
